import { Economics } from "../Economics";
import { ProductsPage } from "../ProductsPage";
import { PanelSection } from "./PanelSection";
import { ScreenFrame } from "./ScreenFrame";
import { SettingsSection } from "./SettingsSection";

const ECONOMICS = [
  "revenue",
  "ai_cost_from_credit_log",
  "margin",
  "users_without_payment",
  "paying_users",
  "payment_conversion",
  "break_even",
  "revenue_per_user_arpu",
  "ai_cost_per_free_user",
  "revenue_cost_and_margin_by_day",
  "by_product_sku",
  "ai_cost_by_reading_type",
  "composite_chart_funnel",
  "cohorts_8_weeks",
  "recalculate_by_rate",
] as const;
const PRODUCTS = [
  "stars_products_telegram_table",
  "product_price_stars",
  "product_active",
  "create_product",
  "free_tier",
] as const;

export function MoneyScreen(): JSX.Element {
  return (
    <ScreenFrame screen="money">
      <SettingsSection screen="money" />
      <PanelSection title="Economics" panelIds={ECONOMICS}>
        <Economics />
      </PanelSection>
      <PanelSection title="Stars products" panelIds={PRODUCTS}>
        <ProductsPage />
      </PanelSection>
    </ScreenFrame>
  );
}
